import {SOPostPrice} from '../../core/price/so-post-price';
import {PriceCore} from './price.core';
import {SOGetPrice} from '../../core/price/so-get-price';
import {FormField, SelectionOption} from 'lionheartland';
import {postPriceFormFieldOptions} from './post-price-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {ProductCore} from '../product/product.core';
import {SOGetProduct} from '../../core/product/so-get-product';

export class RAPostPrice extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postPriceFormFieldOptions);

  RequestClass = SOPostPrice

  constructor(
    public entityCore: PriceCore
  ) {
    super();
    if (postPriceFormFieldOptions.product) {
      postPriceFormFieldOptions.product.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('sku'),
      this.getFormValueFromIdentifier('amount'),
      this.getFormValueFromIdentifier('trailDays'),
      this.getFormValueFromIdentifier('interval'),
      this.getFormValueFromIdentifier(
        'product',
        SOGetProduct,
      ),
      this.getFormValueFromIdentifier('exRef'),
      this.getFormValueFromIdentifier('active'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}